import service from "@/untils/request";
// 获取学校列表
export function schoolList(data) {
  return service({
    url: "/schools?page=1" + "&page_size=1000",
    method: "GET",
    data
  });
}
export function schoolLists(data) {
  return service({
    url: "/schools?page=" + data.page + "&page_size=" + data.pageSize,
    method: "GET",
    data
  });
}
//学校详情
export function schoolDetail(id) {
  return service({
    url: "/schools/" + id,
    method: "GET"
  });
}
//获取学校信息
export function school_info(schoolId) {
  return service({
    url: `/schools/${schoolId}/school_info`,
    method: "GET"
  });
}
//创建学校
export function buildSchool(data) {
  return service({
    url: "/schools",
    method: "POST",
    data
  });
}
//更新学校
export function changeSchool(schoolId, data) {
  return service({
    url: "/schools/" + schoolId,
    method: "PATCH",
    data
  });
}
//删除学校
export function delSchool(id) {
  return service({
    url: "/schools/" + id,
    method: "DELETE"
  });
}

//获取学校管理员列表数据/schools/10014/school_users?page=1
export function schoolMaster(id) {
  return service({
    url: "/schools/" + id + "/school_users?page=1",
    method: "GET"
  });
}

//创建学校管理员
export function creadSchoolMaster(data, id) {
  return service({
    url: "/schools/" + id + "/school_users",
    method: "POST",
    data
  });
}

//创建年级
export function buildSchoolGrades(data, id) {
  return service({
    url: "/schools/" + id + "/grades",
    method: "POST",
    data
  });
}

//删除年级
export function delGarde(id, grades) {
  return service({
    url: "/schools/" + id + "/grades/" + grades,
    method: "DELETE"
  });
}

//获取相应学校的年级列表
export function schoolGrades(id) {
  return service({
    url: "/schools/" + id + "/grades",
    method: "GET"
  });
}

//创建班级
export function buildClass(data, schoolId, gradeId) {
  return service({
    url: "/schools/" + schoolId + "/grades/" + gradeId + "/class_items",
    method: "POST",
    data
  });
}

//创建年级(bll)
export function buildGrade(data, schoolId) {
  return service({
    url: "/schools/" + schoolId + "/grades/",
    method: "POST",
    data
  });
}

//编辑班级
export function updateClass(data, schoolId, gradeId, classId) {
  return service({
    url:
      "/schools/" + schoolId + "/grades/" + gradeId + "/class_items/" + classId,
    method: "PATCH",
    data
  });
}

//更新年级
export function updateGrade(data, schoolId, grades) {
  return service({
    url: "/schools/" + schoolId + "/grades/" + grades,
    method: "PATCH",
    data
  });
}

//添加学生
export function buildStudent(data, schoolId, gradeId, classId) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/grades/" +
      gradeId +
      "/class_items/" +
      classId +
      "/students",
    method: "POST",
    data
  });
}

//更新学生
export function updateStudent(data, schoolId, gradeId, classId, studentId) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/grades/" +
      gradeId +
      "/class_items/" +
      classId +
      "/students/" +
      studentId,
    method: "PATCH",
    data
  });
}

//获取学生列表数据/schools/10014/grades/10027/class_items/10122/students?page=1
export function studentList(schoolId, gradeId, classId, page) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/grades/" +
      gradeId +
      "/class_items/" +
      classId +
      "/students?page=" +
      page,
    method: "GET"
  });
}

export function loadStandards(schoolId, page) {
  return service({
    url: "/schools/" + schoolId + "/standards?page=" + page,
    method: "GET"
  });
}

export function saveStandard(schoolId, standard) {
  console.log(standard.standard.id);
  return service({
    url:
      "/schools/" +
      schoolId +
      "/standards" +
      (standard.standard.id ? "/" + standard.standard.id : ""),
    method: standard.standard.id ? "PATCH" : "POST",
    data: standard
  });
}

export function deleteStandard(schoolId, id) {
  return service({
    url: "/schools/" + schoolId + "/standards" + "/" + id,
    method: "DELETE"
  });
}

export function loadStandardItems(schoolId, standardId) {
  return service({
    url:
      "/schools/" + schoolId + "/standards/" + standardId + "/standard_items",
    method: "GET"
  });
}

export function saveStandardItem(schoolId, standard_item, standardId) {
  console.log(standard_item, standardId);
  const params = {
    standard_item: standard_item
  };
  return service({
    url:
      "/schools/" +
      schoolId +
      "/standards/" +
      standardId +
      "/standard_items" +
      (standard_item.id ? "/" + standard_item.id : ""),
    method: standard_item.id ? "PATCH" : "POST",
    data: params
  });
}

export function deleteStandardItem(schoolId, standardId, standardItemId) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/standards" +
      "/" +
      standardId +
      "/standard_items/" +
      standardItemId,
    method: "DELETE"
  });
}

//获取老师列表/schools/10014/teachers?page=1
export function teacherList(schoolId) {
  return service({
    url: "/schools/" + schoolId + "/teachers?page=1",
    method: "GET"
  });
}

//创建老师/schools/10014/teachers
export function buildTeacher(schoolId, data) {
  return service({
    url: "/schools/" + schoolId + "/teachers",
    method: "POST",
    data
  });
}

//更新老师
export function editTeacher(schoolId, teacherId, data) {
  return service({
    url: "/schools/" + schoolId + "/teachers/" + teacherId,
    method: "PATCH",
    data
  });
}

//删除老师
export function delTeacher(schoolId, teacherId, data) {
  return service({
    url: "/schools/" + schoolId + "/teachers/" + teacherId,
    method: "DEL",
    data
  });
}

//删除分配给老师的班级
export function unBindTeachers(schoolId, teacherId, classId) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/teachers/" +
      teacherId +
      "/class_items/" +
      classId,
    method: "DELETE"
  });
}

//获取老师与设备的绑定列表
export function teacherEquList(schoolId, teacherId) {
  return service({
    url: "/schools/" + schoolId + "/teachers/" + teacherId + "/devices?page=1",
    method: "GET"
  });
}

//获取设备列表/devices?page=1
export function devicesList(page) {
  return service({
    url: "/devices?page=" + page,
    method: "GET"
  });
}

//搜索设备/devices/search?page=1
export function searchDevices(page, schoolId, data) {
  return service({
    url: "/devices/search?page=" + page,
    method: "POST",
    data
  });
}

//将设备和老师进行绑定/schools/10014/teachers/10028/devices
export function DevicesBindTeacher(data, schoolId, teacherId) {
  return service({
    url: "/schools/" + schoolId + "/teachers/" + teacherId + "/devices",
    method: "POST",
    data
  });
}

// 删除设备
export function delDevice(device_id) {
  return service({
    url: "/devices/" + device_id,
    method: "POST"
  });
}

// 获取老师名下的班级信息
export function getClassBindTeacher(schoolId, teacherId) {
  return service({
    url: "/schools/" + schoolId + "/teachers/" + teacherId + "/class_items",
    method: "GET"
  });
}

//将班级和老师进行绑定/schools/10014/teachers/10028/class_items
export function ClassBindTeacher(data, schoolId, teacherId) {
  return service({
    url: "/schools/" + schoolId + "/teachers/" + teacherId + "/class_items",
    method: "POST",
    data
  });
}

// 批量导入学生/schools/10014/grades/10027/class_items/10122/students/batch_create
export function oneClassStudent(data, schoolId, gradeId, classId) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/grades/" +
      gradeId +
      "/class_items/" +
      classId +
      "/students/batch_create",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function bindGradeStandard(schoolId, grade) {
  return service({
    url: `/schools/${schoolId}/grades/${grade.grade_id}/bind_standard?standard_id=${grade.standard_id}`,
    method: "GET"
  });
}

export function batchUploadStudentsByGrade(data, schoolId, gradeId) {
  return service({
    url:
      "/schools/" + schoolId + "/grades/" + gradeId + "/batch_students_create",
    method: "POST",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

//更新学生数据
export function changeStudent(schoolId, gradeId, classId, studentId, data) {
  return service({
    url:
      "/schools/" +
      schoolId +
      "/grades/" +
      gradeId +
      "/class_items/" +
      classId +
      "/students/" +
      studentId,
    method: "PATCH",
    data
  });
}

//删除学生数据
export function delStudent(schoolId, gradeId, classId, studentId) {
  return service({
    url: `/schools/${schoolId}/grades/${gradeId}/class_items/${classId}/students/${studentId}`,
    method: "DELETE"
  });
}

//解除设备组与学校的绑定关系
export function relieveBind(schoolId, groupId) {
  return service({
    url:
      "/device_groups/schools/unbind?school_id=" +
      schoolId +
      "&device_group_id=" +
      groupId,
    method: "POST"
  });
}

//删除班级
export function delClass(schoolId, gradeId, classId) {
  return service({
    url: `/schools/${schoolId}/grades/${gradeId}/class_items/${classId}`,
    method: "DELETE"
  });
}



// WEBPACK FOOTER //
// ./src/api/school.js